var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23815 11.2341C3.34112 11.2341 0.993164 8.88617 0.993164 5.98913C0.993164 3.09209 3.34112 0.744141 6.23815 0.744141C9.13519 0.744141 11.4831 3.09209 11.4831 5.98913C11.4831 8.88617 9.13519 11.2341 6.23815 11.2341ZM5.74644 5.98913C5.74644 6.15304 5.82839 6.3067 5.96566 6.38046L7.93253 7.6917C8.1579 7.85971 8.46318 7.79824 8.59635 7.57287C8.76435 7.3475 8.70289 7.04222 8.47752 6.89061L6.72987 5.72688V3.20273C6.72987 2.93024 6.51065 2.71101 6.21971 2.71101C5.96566 2.71101 5.728 2.93024 5.728 3.20273L5.74644 5.98913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSmall);
export default __webpack_public_path__ + "static/media/Clock_small.e2620866be8325d1b599d494e3d4fc7a.svg";
export { ForwardRef as ReactComponent };